import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import StatusBar from '../components/navigation/StatusBar';
import BottomNav from '../components/navigation/BottomNav';
import GlobalAppStyles from '../styles/appStyles';
import WalletGate from '../components/WalletGate';
import PageTransition from '../components/PageTransition';
import { ToastProvider } from '../contexts/ToastContext';

const APP_WIDTH = 430; // iPhone 14 Pro Max width - fixed mobile app size
const isProductionDomain =
  typeof window !== 'undefined' && window.location.hostname === 'yobitch.fun';

const ENTER_OK_KEY = 'enter_ok';

const AppShell = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [gateOk, setGateOk] = useState(() => {
    if (!isProductionDomain) return true;
    try {
      return sessionStorage.getItem(ENTER_OK_KEY) === '1';
    } catch {
      return false;
    }
  });

  useEffect(() => {
    if (!isProductionDomain) return;
    let cancelled = false;
    const apiBase = process.env.REACT_APP_RAILWAY_URL || 'https://cook.yobitch.fun';
    fetch(`${apiBase}/api/enter/check`, { credentials: 'include' })
      .then(res => {
        if (cancelled) return;
        if (res.ok) {
          try { sessionStorage.setItem(ENTER_OK_KEY, '1'); } catch (_) { /* sessionStorage unavailable */ }
          setGateOk(true);
        } else {
          try { sessionStorage.removeItem(ENTER_OK_KEY); } catch (_) { /* sessionStorage unavailable */ }
          setGateOk(false);
          navigate('/', { replace: true });
        }
      })
      .catch(() => {
        if (cancelled) return;
        try {
          if (sessionStorage.getItem(ENTER_OK_KEY) === '1') {
            setGateOk(true);
            return;
          }
        } catch (_) { /* sessionStorage unavailable */ }
        setGateOk(false);
        navigate('/', { replace: true });
      });
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  if (isProductionDomain && !gateOk) {
    return null;
  }

  return (
    <WalletGate>
      <GlobalAppStyles />
      <ToastProvider>
        {/* App Container - Fixed mobile width, centered on desktop */}
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            width: '100%',
            maxWidth: `${APP_WIDTH}px`,
            height: '100%',
            background: '#000000',
            boxShadow: '0 0 60px rgba(0, 0, 0, 0.8)',
            overflow: 'hidden',
          }}
        >
          {/* Fixed Header */}
          <StatusBar />

          {/* Main Content Area - Scrollable */}
          <main
            style={{
              position: 'absolute',
              top: '72px',
              left: 0,
              right: 0,
              bottom: '80px',
              overflowY: 'auto',
              overflowX: 'hidden',
              WebkitOverflowScrolling: 'touch',
              background: '#000000',
              touchAction: 'pan-y',
            }}
          >
            {/* Content container */}
            <div
              style={{
                width: '100%',
                padding: '12px 14px',
                paddingBottom: '20px',
                minHeight: '100%',
                boxSizing: 'border-box',
              }}
            >
              <PageTransition>
                <Outlet key={location.pathname} />
              </PageTransition>
            </div>
          </main>

          {/* Fixed Bottom Navigation */}
          <BottomNav />
        </div>
      </ToastProvider>
    </WalletGate>
  );
};

export default AppShell;
